// extracted by mini-css-extract-plugin
export var border = "_q-8";
export var brand = "_q-t";
export var button = "_q-l";
export var center = "_q-a";
export var centered = "_q-6";
export var closeButton = "_q-c";
export var disabledWrapper = "_q-m";
export var error = "_q-p";
export var extraLarge = "_q-4";
export var extraSmall = "_q-1";
export var fill = "_q-i";
export var footer = "_q-h";
export var footerAction = "_q-j";
export var footerButtons = "_q-k";
export var header = "_q-7";
export var headerWithClose = "_q-d";
export var icon = "_q-o";
export var info = "_q-s";
export var inline = "_q-9";
export var large = "_q-3";
export var main = "_q-e";
export var modal = "_q-0";
export var nearFull = "_q-5";
export var neutral = "_q-u";
export var noPadding = "_q-g";
export var none = "_q-v";
export var scrollable = "_q-f";
export var small = "_q-2";
export var success = "_q-r";
export var tight = "_q-n";
export var titleIcon = "_q-b";
export var warn = "_q-q";